import { type FC, lazy, Suspense } from "react"

import { exhaustiveGuard } from "@forento/shared/utilities/switch"

import { BunnyPlayer } from "../VideoPlayer"

const ApiVideo = lazy(() => import("./ApiVideo"))

type Props = {
	video: { playableDate?: Date | null; id?: number } & (
		| { host: "apiVideo"; apiVideoId: string }
		| { host: "bunny"; bunnyVideoId: string }
	)
	onTrackWatch?(progress: number): void
	className?: string
}
const HostedVideoPlayer: FC<Props> = ({ video, onTrackWatch, className }) => {
	if (video.playableDate === null) {
		return (
			<div className="absolute inset-0 flex items-center justify-center text-2xl font-semibold">
				Processing...
			</div>
		)
	}

	switch (video.host) {
		case "bunny": {
			return <BunnyPlayer videoId={video.bunnyVideoId} onTrackWatch={onTrackWatch} className={className} />
		}
		case "apiVideo": {
			return (
				<Suspense fallback={<div>Loading...</div>}>
					<ApiVideo apiVideoId={video.apiVideoId} className={className} />
				</Suspense>
			)
		}
		default:
			return exhaustiveGuard(video)
	}
}

export default HostedVideoPlayer
